"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IconButton = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _manifest_icons = _interopRequireDefault(require("../Icon/manifest_icons"));
var _constants = require("../utils/constants");
var _Icon = require("../Icon/Icon");
var _Button = require("../Buttons/Button");
var _Tooltip = require("../Tooltip/Tooltip");
var _IconButton = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./IconButton.css") : void 0);
var _excluded = ["ariaLabel", "children", "className", "iconName", "iconProps", "size", "tooltipDelay", "tooltipMsg", "tooltipProps", "inToolbarOverflow", "type"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; } // generated; see scripts/buildIconManifest.js
var CSS_BLOCK = 'sapcnqr-icon-button';

/**
 * **IconButton** is specialized button component that only allows an
 * icon for the button content.  Since the button only contains an icon,
 * it is wrapped with a **Tooltip** to improve the accessibility.
 *
 * > **IconButton** and **IconLink** components are sometimes used interchangeably,
 * but from an accessibility perspective, there are specific use cases for each.
 * Please see [Design Usage for Link Button and Link](./?path=/docs/design-buttons--docs)
 * for the distinction between the two and proper usage.
 */

var IconButton = exports.IconButton = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _context;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(IconButton, _props)) : _props;
  var ariaLabel = props.ariaLabel,
    children = props.children,
    className = props.className,
    iconName = props.iconName,
    iconProps = props.iconProps,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    _props$tooltipDelay = props.tooltipDelay,
    tooltipDelay = _props$tooltipDelay === void 0 ? 300 : _props$tooltipDelay,
    tooltipMsg = props.tooltipMsg,
    tooltipProps = props.tooltipProps,
    inToolbarOverflow = props.inToolbarOverflow,
    _props$type = props.type,
    type = _props$type === void 0 ? 'link' : _props$type,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_IconButton.default);
  var hideTooltip = tooltipDelay < 0;
  var classes = classnames(className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK), !inToolbarOverflow), (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, size), size !== 'md'), "".concat(CSS_BLOCK, "--wide"), type === 'create' && !(otherProps !== null && otherProps !== void 0 && otherProps.hideCreateIcon)));
  var buttonContent = /*#__PURE__*/_react.default.createElement(_Button.Button, (0, _extends2.default)({}, otherProps, {
    "aria-label": ariaLabel,
    className: classes,
    ref: ref,
    size: size,
    type: type
  }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, (0, _extends2.default)({}, iconProps, {
    ariaHidden: true,
    iconName: iconName
  })), children);
  if (inToolbarOverflow) {
    buttonContent = /*#__PURE__*/_react.default.createElement(_Button.Button, (0, _extends2.default)({}, otherProps, {
      type: type,
      className: classes,
      ref: ref,
      size: size,
      inToolbarOverflow: true
    }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, (0, _extends2.default)({}, iconProps, {
      ariaHidden: true,
      iconName: iconName
    })), ariaLabel);
  }
  if (!hideTooltip && !inToolbarOverflow) {
    var ariaLabelSameAsTooltip = !tooltipMsg || tooltipMsg === ariaLabel;
    buttonContent = /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, (0, _extends2.default)({
      "aria-hidden": true,
      placement: ['top', 'bottom', 'auto']
    }, tooltipProps, {
      delay: tooltipDelay,
      message: tooltipMsg || ariaLabel,
      doNotDescribe: ariaLabelSameAsTooltip
    }), buttonContent);
  }
  return /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: null
  }, buttonContent);
});
IconButton.displayName = 'IconButton';
IconButton.propTypes = _objectSpread(_objectSpread({}, _Button.Button.propTypes), {}, {
  /** Text to describe the **IconButton**. The value is placed in the 'aria-label' attribute. */
  ariaLabel: _propTypes.default.string.isRequired,
  /** The name of the desired icon. See Available Icons example for a complete list.
   *
   * Note: If using any 'messaging-' icons, this component will render an `<svg>`
   * element, all other icons render an `<i>` element. */
  iconName: _propTypes.default.oneOf(_manifest_icons.default).isRequired,
  /** Additional props to be spread to the button **Icon**. */
  iconProps: _propTypes.default.object,
  /** **Button** size. Options are 'lg', 'md'. */
  size: _propTypes.default.oneOf(_constants.CONTROL_SIZES),
  /** Delay (in milliseconds) before tooltip appears. Pass in `-1` to disable the tooltip. */
  tooltipDelay: _propTypes.default.number,
  /** Content to display in the tooltip message. If not supplied, `ariaLabel` will be used. */
  tooltipMsg: _propTypes.default.node,
  /** Tooltip props. */
  tooltipProps: _propTypes.default.object,
  /** **Button** type. Options are 'primary', 'default', 'link'. */
  type: _propTypes.default.oneOf(_Button.BUTTON_TYPES)
});
var _default = exports.default = IconButton;